import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const UserSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0021 12.006C14.2081 12.006 16.0021 10.211 16.0021 8.00598C16.0021 5.80098 14.2081 4.00598 12.0021
      4.00598C9.79608 4.00598 8.00208 5.80098 8.00208 8.00598C8.00208 10.211 9.79708 12.006 12.0021 12.006Z"
      fill="currentColor"
    />
    <path d="M12.0021 13.006C7.29208 13.006 4.00208 15.473 4.00208 19.006V20.006H20.0021V19.006C20.0021 15.473 16.7131 13.006 12.0021 13.006Z" fill="currentColor" />
  </svg>
);

const User = (props: IIconProps) => <Icon component={UserSvg} {...props} />;

export default User;
